<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columnsPolicy"
      :data="policyData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="configure">
        <Button
          type="info"
          size="small"
          @click="patchBaselineConfiguration(row)"
          v-hasPermission="['patchManagement:policies:patch_baseline_config']"
          style="margin-bottom: 2px"
          >{{ $t("PatchEasy.PatchPolicy.patchstdConfig") }}</Button
        >
        <Button
          type="info"
          size="small"
          @click="patchCommandParameters(row)"
          v-hasPermission="['patchManagement:policies:cmd_parameter']"
          style="margin-bottom: 2px"
          >{{ $t("PatchEasy.PatchPolicy.patchcmdPara") }}</Button
        >
      </template>
      <template slot-scope="{ row, index }" slot="operations"></template>
    </Table>

    <!-- 删除策略弹出框 -->
    <Modal v-model="policyDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ policyName }}?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="removePolicy_loading"
          @click="removePolicy()"
          :disabled="isDisables"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>

    <!-- 立即运行弹出框 -->
    <Modal v-model="runASAPmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="ios-checkmark-circle" />
        <span>{{ $t("PatchEasy.PatchPolicy.instantRun") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureRunImmediately") }} {{ policyName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="success"
          size="large"
          long
          :loading="runASAP_loading"
          @click="runASAP()"
          :disabled="isDisable"
          >{{ $t("PatchEasy.PatchPolicy.instantRun") }}</Button
        >
      </div>
    </Modal>

    <!-- 编辑策略弹出框 -->
    <div v-if="showPoliciesModal">
      <edit-policies
        @on-close-cancel="onCloseCancel"
        :policiesEditOldForm="policyEditForm"
      ></edit-policies>
    </div>
    <!-- 分页 -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import EditPolicies from "../policy/EditPolicies.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tablePolicyVue = {};
export default {
  name: "TablePolicies",
  components: {
    EditPolicies
  },
  data() {
    return {
      showPoliciesModal: false,
      policyEditForm: {}, //编辑策略
      val: "",
      current: 1,
      pageSize: 10,
      dataTotal: 0, //分页
      lineIndex: 0,
      index: 0,
      policyName: "",
      isDisables: false,
      removePolicy_loading: false,
      policyDelmodal: false, //删除策略
      isDisable: false,
      runASAPmodal: false,
      runASAP_loading: false, //立即运行
      columnsPolicy: [
        {
          title: this.$t("PatchEasy.PatchPolicy.policyName"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.showPoliciesModal = true;
                    this.policyEditForm = params.row;
                    this.$emit("on-open-modal");
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t("PatchEasy.PatchPolicy.account"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "stateName",
          width: "150px"
        },
        {
          title: this.$t("PatchEasy.PatchPolicy.dispatchDuty"),
          key: "scheduleManagementName"
        },
        {
          title: this.$t("PatchEasy.PatchPolicy.config"),
          slot: "configure",
          width: "250px"
        },
        {
          title: this.$t("common.operation"),
          slot: "operations",
          width: "250px",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px",
                    "margin-bottom": "2px"
                  },
                  on: {
                    click: () => {
                      this.findRowIndex(params.index);
                      this.policyDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array("patchManagement:policies:delete")
                    }
                  ]
                },
                this.$t("patch_management.patch_policy.deletePolicy")
              ),
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px",
                    "margin-bottom": "2px"
                  },
                  on: {
                    click: () => {
                      this.findRowIndex(params.index);
                      this.runASAPmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array("patchManagement:policies:excute")
                    }
                  ]
                },
                this.$t("patch_management.patch_policy.runImmediately")
              ),
              h(
                "i-switch",
                {
                  // 数据库0启用,1禁用
                  props: {
                    type: "primary",
                    size: "large",
                    value:
                      params.row.stateName ==
                      this.$t("patch_management.patch_policy.start") // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.changeStatusMessage(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t("patch_management.patch_policy.start")
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t("patch_management.patch_policy.close")
                    }
                  })
                ]
              )
            ]);
          }
        }
      ],
      policyData: []
    };
  },
  beforeCreate: function() {
    tablePolicyVue = this;
  },
  mounted: function() {
    tablePolicyVue.getPoliciesData();
  },
  methods: {
    /**************************************分页查询策略*************************************/
    showAll: function() {
      tablePolicyVue.getPoliciesData();
    },
    // 返回分页查询Policy列表
    getPoliciesData: function() {
      // 获取PoliciesSearch里面的搜索内容
      eventBus.$on("schedulePoliciesName", function(val) {
        tablePolicyVue.val = val;
      });
      // 策略列表分页
      this.$api.policy
        .pagePolicy({
          // 'name': tablePolicyVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.policyData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tablePolicyVue.getPoliciesData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tablePolicyVue.getPoliciesData();
    },
    // 销毁schedulePoliciesName
    beforeDestroy: function() {
      eventBus.$off("schedulePoliciesName");
    },
    /**************************************页面跳转*************************************/
    // 补丁基准配置
    patchBaselineConfiguration: function(row) {
      this.$router.push({
        path: "/patchManagement/patchBaselineConfiguration/"
      });
    },
    // 补丁命令参数
    patchCommandParameters: function(row) {
      this.$router.push({
        path: "/patchManagement/addOrUpdateRunCommands",
        query: {
          patchPolicyId: row.id,
          accountId: row.accountId,
          region: row.region
        }
      });
    },
    /**************************************删除策略*************************************/
    // 找index
    findRowIndex: function(index) {
      this.lineIndex = index;
      this.policyName = this.policyData[index].name;
    },
    // 点击模式框的删除
    removePolicy: function() {
      this.isDisables = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 策略删除
      this.$api.policy
        .deletePolicy("id", this.policyData[lineIndex].id)
        .then(res => {
          this.removePolicy_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tablePolicyVue.getPoliciesData();
            this.isDisables = false;
            this.removePolicy_loading = false;
            this.policyDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    /**************************************立即运行*************************************/
    // 立即运行
    runASAP: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 立即运行
      this.$api.policy
        .runPatch("patchPolicyId", this.policyData[lineIndex].id)
        .then(res => {
          this.runASAP_loading = true;
          setTimeout(() => {
            this.isDisable = false;
            this.runASAP_loading = false;
            this.runASAPmodal = false;
            this.$Message.success("运行成功");
          }, 1000);
        });
    },
    /**************************************编辑策略*************************************/
    onCloseCancel(bool) {
      this.showPoliciesModal = bool;
    },
    /**************************************启用禁用*************************************/
    // 更新反馈信息某一字段
    changeStatusMessage: function(index) {
      // 编辑策略
      this.$api.policy
        .changeStatus("id", this.policyData[index].id)
        .then(res => {
          tablePolicyVue.getPoliciesData();
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/TablePolicies.vue